import { cn } from '@/lib/utils'

interface TourBodyProps {
  children: React.ReactNode
  className?: string
}

export function TourBody({ children, className }: TourBodyProps) {
  return <div className={cn('flex flex-col space-y-3 mb-4', className)}>{children}</div>
}
